import { configureStore } from '@reduxjs/toolkit'
import categoryReducer from './reducers/categoryReducer'
import brandReducer from './reducers/brandReducer'
import exchangeRateReducer from './reducers/exchangeRateReducer'
import printerReducer from './reducers/printerReducer'
import customerReducer from './reducers/customerReducer'
import bankReducer from './reducers/bankReducer'
import stockAlmostGonesReducer from './reducers/stockAlmostGonesReducer'
import saleHis from './reducers/saleHis'
import roleReducer from './reducers/roleReducer'
import cartReducer from './reducers/cartReducer'


const rootReducer = {
    category: categoryReducer,
    brands: brandReducer,
    exchange: exchangeRateReducer,
    printer: printerReducer,
    customer: customerReducer,
    bank: bankReducer,
    stock: stockAlmostGonesReducer,
    salehis: saleHis,
    permissions: roleReducer,
    cart: cartReducer
}

export default configureStore({
    reducer: rootReducer
})